import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledEventBarrier = styled.span.withConfig({
  displayName: "EventBarrier__StyledEventBarrier"
})(["all:unset;display:inline;margin:0;padding:0;"]);
/**
 * EventBarrier intercepts and controls event handling for child elements.
 * A common use case is preventing a table cell from entering edit mode
 * when interacting with nested interactive elements (like buttons or inputs).
 */
export const EventBarrier = ({
  children,
  onEventCapture
}) => {
  return /*#__PURE__*/_jsx(StyledEventBarrier, {
    onClick: onEventCapture,
    onKeyDown: onEventCapture,
    onKeyUp: onEventCapture,
    children: children
  });
};